import { useTranslation } from '@/shared/hooks/useTranslation'

import { isBonusResolution } from './navigateFromQrResolution'
import type { QrResolution } from './resolveQrCode'

type Alert = { variant: 'warning' | 'info'; title: string; description: string }

const CHECKIN_UNAVAILABLE: Alert = {
  variant: 'warning',
  title: 'Check-in ainda não disponível',
  description:
    'Este check-in não está aberto no momento. Você pode conferir a página e tentar novamente mais tarde.'
}

export const getUnavailableAlert = (
  resolution: Extract<QrResolution, { status: 'unavailable' }>
): Alert => {
  if (!isBonusResolution(resolution.resourceType)) return CHECKIN_UNAVAILABLE

  const { t } = useTranslation()
  const reason = resolution.resource?.unavailable_reason as string | undefined

  const reasonMap: Record<string, Alert> = {
    limit_reached: {
      variant: 'warning',
      title: t('bonus.unavailable.limitReachedTitle'),
      description: t('bonus.unavailable.limitReachedDescription')
    },
    expired: {
      variant: 'warning',
      title: t('bonus.unavailable.expiredTitle'),
      description: t('bonus.unavailable.expiredDescription')
    },
    not_yet_active: {
      variant: 'info',
      title: t('bonus.unavailable.notYetActiveTitle'),
      description: t('bonus.unavailable.notYetActiveDescription')
    },
    channel_inactive: {
      variant: 'warning',
      title: t('bonus.unavailable.channelInactiveTitle'),
      description: t('bonus.unavailable.channelInactiveDescription')
    },
    stock_exhausted: {
      variant: 'warning',
      title: t('bonus.unavailable.stockExhaustedTitle'),
      description: t('bonus.unavailable.stockExhaustedDescription')
    },
    not_active: {
      variant: 'warning',
      title: t('bonus.unavailable.notActiveTitle'),
      description: t('bonus.unavailable.notActiveDescription')
    }
  }

  return (
    (reason && reasonMap[reason]) || {
      variant: 'warning',
      title: t('bonus.unavailableAlertTitle'),
      description: t('bonus.unavailableAlertDescription')
    }
  )
}
